import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getDynamicGroup = createAsyncThunk(
  '/getDynamicGroup',
  async () => {
    const response = await axios.get('/GetDynamicGroup');
    return response.data;
  }
);

export const createDynamicGroup = createAsyncThunk(
  '/createDynamicGroup',
  async (req) => {
    const response = await axios.post(`/CreateDynamicGroup/${req}`);
    return response.data;
  }
);

export const updateDynamicGroup = createAsyncThunk(
  '/updateDynamicGroup',
  async (req) => {
    const response = await axios.post(`/UpdateDynamicGroup`, req);
    return response.data;
  }
);


const dynamicGroupSlice = createSlice({
  name: 'dynamicGroup',
  initialState: {
    loading: false,
    error: '',
    dynamicGroup: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    resetDescriptions(state) {
      state.dynamicGroup = [];
    },

  },

  extraReducers: {
    [getDynamicGroup.pending]: (state) => {
      state.loading = true;
    },
    [getDynamicGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDynamicGroup.fulfilled]: (state, action) => {
      state.dynamicGroup = action.payload === '' ? []: action.payload;
      state.loading = false;
    },
    [createDynamicGroup.pending]: (state) => {
      state.loading = true;
    },
    [createDynamicGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [createDynamicGroup.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateDynamicGroup.pending]: (state) => {
      state.loading = true;
    },
    [updateDynamicGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [updateDynamicGroup.fulfilled]: (state, action) => {
      state.loading = false;
    }
  }
});

export const dynamicGroupActions = dynamicGroupSlice.actions;

export default dynamicGroupSlice;
